export default {
  internal: {
    group: [
      {
        text: 'Group',
        align: 'left',
        value: 'groupName',
        truncate: true,
        maxChars: 85
      },
      { text: 'Group Details', value: 'groupDetails' },
      { text: 'Group ID', value: 'groupId' },
      { text: '', value: 'select', sortable: false },
      { text: 'Group CK', value: 'groupCk', visible: false },
    ],
    parentGroup: [
      {
        text: 'Parent Group',
        align: 'left',
        value: 'parentGroupName',
        truncate: true,
        maxChars: 85
      },
      // { text: 'Group Details', value: 'groupDetails' },
      { text: 'Parent Group ID', value: 'parentGroupId' },
      { text: '', value: 'select', sortable: false },
      { text: 'Parent Group CK', value: 'parentGroupCk', visible: false }
    ],
    subGroup: [
      {
        text: 'Subgroup',
        align: 'left',
        value: item => `${item.subGroupName} - ${item.subGroupId}`,
        truncate: true,
        maxChars: 55
      },
      { text: 'Effective Date', value: 'effectiveDate' },
      { text: 'Term Date', value: 'terminationDate' },
      { text: 'Subgroup Details', value: 'groupDetails' },
      {
        text: 'Group',
        value: item => `${item.groupName} - ${item.groupId}`,
        visible: false,
        truncate: true
      },
      { text: '', value: 'select', sortable: false },
      { text: 'Group CK', value: 'groupCk', visible: false },
    ],
  },
  external: {
    group: [
      {
        text: 'Group',
        align: 'left',
        value: 'groupName',
        truncate: true,
        maxChars: 85
      },
      { text: 'Group Details', value: 'groupDetails' },
      { text: 'Group ID', value: 'groupId' },
      { text: '', value: 'select', sortable: false },
      { text: 'Group CK', value: 'groupCk', visible: false },
    ],
    parentGroup: [
      {
        text: 'Parent Group',
        align: 'left',
        value: 'parentGroupName',
        truncate: true,
        maxChars: 85
      },
      // { text: 'Group Details', value: 'groupDetails' },
      { text: 'Parent Group ID', value: 'parentGroupId' },
      { text: '', value: 'select', sortable: false },
      { text: 'Parent Group CK', value: 'parentGroupCk', visible: false }
    ],
    subGroup: [
      {
        text: 'Subgroup',
        align: 'left',
        value: item => `${item.subGroupName} - ${item.subGroupId}`,
        truncate: true,
        maxChars: 55
      },
      { text: 'Effective Date', value: 'subGroupEffectiveDate' },
      { text: 'Term Date', value: 'subGroupTerminationDate' },
      { text: 'Subgroup Details', value: 'groupDetails' },
      {
        text: 'Group',
        value: item => `${item.groupName} - ${item.groupId}`,
        visible: false,
        truncate: true
      },
      { text: '', value: 'select', sortable: false },
      { text: 'Group CK', value: 'groupCk', visible: false }
    ]
  }
}